var localizeDelta = (delta, angleRad) => {
  return {
    x: delta.x * Math.cos(angleRad) - delta.y * Math.sin(angleRad),
    y: delta.x * Math.sin(angleRad) + delta.y * Math.cos(angleRad),
  }
}

const calcGlobalPos = (dim, angleRad, globalTL) => {
  const curAngleRad = angleRad

  // 2
  const localTL = {
    top: -dim.height / 2,
    left: -dim.width / 2,
  }

  const localRotatedTL = {
    left: localTL.left * Math.cos(curAngleRad) - localTL.top * Math.sin(curAngleRad),
    top: localTL.left * Math.sin(curAngleRad) + localTL.top * Math.cos(curAngleRad),
  }

  const deltaTL = {
    x: localRotatedTL.left - localTL.left,
    y: localRotatedTL.top - localTL.top,
  }
  const globalRotatedTL = {
    top: parseFloat(globalTL.top) + deltaTL.y,
    left: parseFloat(globalTL.left) + deltaTL.x,
  }
  return globalRotatedTL
}

const calculateAngle = coordinates => {
  var _radians = Math.atan2(coordinates.mousex, coordinates.mousey)
  var _degrees = _radians * (180 / Math.PI) * -1
  _degrees = _degrees >= 360 ? _degrees - 360 : _degrees
  _degrees = _degrees <= -360 ? _degrees + 360 : _degrees
  return {degrees: _degrees, radians: _radians}
}

const subAngle = (a, b) => {
  var _radians = a.radians - b.radians
  var _degrees = _radians * (180 / Math.PI) * -1
  _degrees = _degrees >= 360 ? _degrees - 360 : _degrees
  _degrees = _degrees <= -360 ? _degrees + 360 : _degrees
  return {degrees: _degrees, radians: _radians}
}

const degToRad = degrees => {
  return degrees * (Math.PI / 180)
}

const calculateAB = point => {
  const cLen = Math.sqrt(point.x * point.x + point.y * point.y)
  const angleA = calculateAngle({mousex: point.x, mousey: point.y})
  const adjustedAngle = (angleA.degrees - 90) % 90
  const rad = degToRad(Math.abs(adjustedAngle))
  const aLen = cLen * Math.sin(rad) // y
  const bLen = cLen * Math.cos(rad) // x
  const xSign = point.x < 0 ? -1 : 1
  const ySign = point.y < 0 ? -1 : 1
  if ((point.x === 0) & (adjustedAngle === 0)) {
    return {
      x: aLen * xSign,
      y: bLen * ySign,
    }
  } else if (point.x > 0 && point.y > 0) {
    return {
      x: aLen * xSign,
      y: bLen * ySign,
    }
  } else {
    return {
      x: bLen * xSign,
      y: aLen * ySign,
    }
  }
}

export {localizeDelta, calcGlobalPos, calculateAngle, subAngle, degToRad, calculateAB}
